import { render, staticRenderFns } from "./ResultsPriority.vue?vue&type=template&id=9ae179ec&"
import script from "./ResultsPriority.vue?vue&type=script&lang=js&"
export * from "./ResultsPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports